import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractRestService, GenericLambdaReturn } from '@gea-mes/cognito';

@Injectable({
  providedIn: 'root'
})
export class SeverityViewService extends AbstractRestService {
  postInit(): void {}

  getDetailData(CurrentShift: string = "True", 
               StartDate: string = "", 
               EndDate: string = "", 
               plant: string = "", 
               line?: string, 
               severity?: string,
               resultID?: string,
               offset?: number) :Observable<GenericLambdaReturn<any>> {
    let params:any={
      "CurrentShift": CurrentShift,
      "StartDate": StartDate,
      "EndDate": EndDate,
      "Site": plant
    };

    line ? params.Line = line:null;
    severity ? params.Severity = severity:null;
    resultID ? params.ResultID = resultID:"";
    offset !== undefined ? params.Offset = offset : null;

    return this.get({
      ApiResource: '/details',
      data: params
    });
  }


  getAllDetailData(
    CurrentShift: string = "True",
    StartDate: string = "",
    EndDate: string = "",
    plant: string = "",
    line?: string,
    severity?: string,
    offset: number = 0   // add this
  ): Observable<SeverityLambdaReturn> {

    let params: any = {
      CurrentShift,
      StartDate,
      EndDate,
      Site: plant,
      Offset: offset    // dynamic offset
    };

    if (line) params.Line = line;
    if (severity) params.Severity = severity;

    return this.get({
      ApiResource: '/details',
      data: params
    });
  }

  getpic(ResultId: string, field: string, site: string):Observable<Blob> {
    let params: any = {};

    params.ResultID = ResultId;
    params.Field = field;
    params.Site =  site;
  
    console.log(' Inside service severity ')
    return this.getBinary({
      ApiResource: "/picture",
      data: params
    });
  }

  updateAcknowledgementDetails(Site:string, ResultID:string, Comment:string ,Userid:string , Acknowledgeresultdid:string) :Observable<GenericLambdaReturn<any>>
  {
    let params: any = { };

    params.site = Site
    params.resultID = ResultID
    params.comment = Comment
    params.userid = Userid
    params.update = (Acknowledgeresultdid != null) ? 1 : 0;

    console.log(params);
    console.log(Acknowledgeresultdid);


    return this.post({
      ApiResource: "/acknowledge",
      data: {data: params},
      repeatCall: false
    })

  }

}

export type SeverityType = {
  ShiftDate: string;
  Shift: string;
  site: string;
  Line: string;
  ResultDateTime: string;
  Model: string;
  Serial: string;
  ResultId : string;
  AreaDescription: string;
  ComponentDescription: string;
  DefectDescription: string;
  Severity: string;
  Note: string;
  OperatorName: string;
  Acknowledgeresultid : string;
  Image1:boolean;
  Image2:boolean;
  VariableData1: string; 
  VariableData2: string;
  CustomData1: string;
  CustomData2: string;
  CustomData3: string;
  CustomData4: string;
  CustomData5: string;
  CustomData6: string;
  CustomData7: string;
  CustomData8: string;
  CustomData9: string;
  CustomData10: string;
  VariableData1Name: string; 
  VariableData2Name: string;
  CustomData1Name: string;
  CustomData2Name: string;
  CustomData3Name: string;
  CustomData4Name: string;
  CustomData5Name: string;
  CustomData6Name: string;
  CustomData7Name: string;
  CustomData8Name: string;
  CustomData9Name: string;
  CustomData10Name: string;
  DetailsExist: boolean;
  comment: string;
  InsertDatetime: string;
  UpdateDatetime: string;
  UserID: string;
}

export type AcknowledgeDetailType = {
  Comment :string;
  InsertDate :string;
  UpdateDate :string;
  UserID :string;
}

export interface SeverityLambdaReturn extends GenericLambdaReturn<SeverityType[]> {
  HasMore: boolean;
  Offset: number;
}